import { useEffect } from "react";
import { LeftArrowSVG, RightArrowSVG } from "../../svg";
import { useRef } from 'react';
import { Carousel } from "@crunchyroll/cx-web-components";
import styles from "./refCardsCarousel.module.scss";

function RefCardsCarousel({
  children,
  withClass,
  extraSmallOptions, //Options object consists of perPage and gap (gap between cards can be specified as a string with px or a number)
  mobileOptions,
  mobileExtendedOptions,
  smallTabletOptions,
  tabletOptions,
  desktopOptions,
  arrowClass,
}) {



  const carouselContainerRef = useRef(null);

  const setViewportLayout = ({ perPage, gap }, viewport) => {
    const carouselEl = carouselContainerRef.current.getElementsByClassName(
      `${styles.cardsCarousel}`
    )[0];

    if (!carouselEl) return;
    if (perPage) {
      carouselEl.style.setProperty(`--${viewport}-cols`, perPage);
    }
    if (gap) {
      carouselEl.style.setProperty(`--${viewport}-gap`, typeof gap === 'string' ? gap : `${gap}px`);
    }
  };

  /* istanbul ignore next */
  useEffect(() => {
    setViewportLayout({
      perPage: 2, gap: '10px', ...extraSmallOptions
    }, "extra-small");
    setViewportLayout({ perPage: 2, gap: '24px', ...mobileOptions }, "mobile");
    setViewportLayout({ perPage: 3, gap: '24px', ...mobileExtendedOptions }, "mobile-extended");
    setViewportLayout({ perPage: 4, gap: '24px', ...smallTabletOptions }, "small-tablet");
    setViewportLayout({ perPage: 5, gap: '24px', ...tabletOptions }, "tablet");
    setViewportLayout({ perPage: 6, gap: '24px', ...desktopOptions }, "desktop");
  }, [
    extraSmallOptions,
    mobileOptions,
    mobileExtendedOptions,
    smallTabletOptions,
    tabletOptions,
    desktopOptions,
  ]);

  return (
    <div
      ref={carouselContainerRef}
      className={`${styles.carouselContainer} ${withClass}`}
    >
      <Carousel
        className={styles.cardsCarousel}
        onOffsetChange={function noRefCheck() {}}
        onStepView={function noRefCheck() {}}
      >
        <Carousel.Arrow
          className={`${styles.arrow} ${styles.leftArrow} ${arrowClass}`}
          hiddenClassName={styles.arrowIsHidden}
          dataT="left-arrow"
          ariaLabel="previous"
          direction="start"
        >
          <LeftArrowSVG />
        </Carousel.Arrow>

        <div className={styles.scroller}>
          <Carousel.Scroller>{children}</Carousel.Scroller>
        </div>

        <Carousel.Arrow
          className={`${styles.arrow} ${styles.rightArrow} ${arrowClass}`}
          hiddenClassName={styles.arrowIsHidden}
          dataT="right-arrow"
          ariaLabel="next"
          direction="end"
        >
          <RightArrowSVG />
        </Carousel.Arrow>
      </Carousel>
    </div>
  );
}

export default RefCardsCarousel;